const data = {
  "code": 0,
  "data": "",
  "message": "success"
}

export default {
  getBackPassword(config) {
    return data
  }
}



// WEBPACK FOOTER //
// ./src/mock/forget.js